import React, { Fragment, useCallback, useState, useEffect } from 'react';

import { useParams } from 'react-router-dom';
import HeaderNew from './HeaderNew';
import { useDropzone } from 'react-dropzone';
import { useSnackbar } from 'notistack';
import { PromiseQueue } from './queue';
import { cleanPath, formatFilename, addExitPopup, removeExitPopup } from './MediaUploaderNewHelper';
import axios from 'axios';
import { getSignedUrl, bytesToSize, remainigPercentFormat, secondsToTime } from './dropzoneHelper';
import UploadCompleteModal from './UploadCompleteModal';

import config, { API } from '../../config';

import '../../media-uploader.css';

function FileStatusIcon({ uploaded }) {
  if (uploaded === 'uploaded') {
    return (
      <div className="uploader-check-mark">
        <img src="../../../check-mark.svg" alt="" />
      </div>
    );
  } else if (uploaded === 'queued') {
    return (
      <div className="uploader-check-mark">
        <img src="../../../pending.svg" alt="" />
      </div>
    );
  } else {
    return (
      <div className="uploader-check-mark">
        <img src="../../../error.svg" alt="" />
      </div>
    );
  }
}

export default function MediaUploaderNew() {
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [sortBy, setSortBy] = useState('error');
  const [loading, setLoading] = useState(true);
  const [alreadyCount, setAlreadyCount] = useState(0);
  const [alreadyDate, setAlreadyDate] = useState('');
  const [alreadyUploadedFiles, setAlreadyUploadedFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [totalFailed, setTotalFailed] = useState(0);
  const [totalPending, setTotalPending] = useState(0);
  const [totalUploaded, setTotalUploaded] = useState(0);
  const [filesQueue, setFilesQueue] = useState([]);
  const [acceptedFileState, setAcceptedFileState] = useState([]);
  const [uploadStarted, setUploadStarted] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  const [allFileTotalSize, setAllFileTotalSize] = useState(0);
  const [currentKbps, setCurrentKbps] = useState(0);
  const [totalFilesRemaining, setTotalFilesRemaining] = useState(0);
  const [totalSizeRemaining, setTotalSizeRemaining] = useState(0);
  const [delayQueueState, setDelayQueueState] = useState(null);
  const { SFMediaSubmissionID } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [startMarkedInSF, setStartMarkedInSF] = useState(false);
  const [showFailedFiles, setShowFailedFiles] = useState(true);
  const [showPendingFiles, setShowPendingFiles] = useState(true);
  const [showCompletedFiles, setShowcompletedFiles] = useState(true);

  useEffect(() => {
    setLoading(true);
    const alreadyStatsUrl = `${API}/v1/upload/${SFMediaSubmissionID}/alreadyStats`;
    axios
      .get(alreadyStatsUrl)
      .then((d) => {
        console.log('[I] alreday stats api response', d);
        addExitPopup();

        if (d.data.allFiles && d.data.allFiles.length) {
          console.log('Some files already uploaded', d.data.allFiles);
          setAlreadyUploadedFiles(d.data.allFiles);
          setTotalUploaded(d.data.allFiles.length);
        }

        if (d.data && d.data.success) {
          setAlreadyCount(d.data.SFMediaSubmission.Number_of_Images__c);
          setAlreadyDate(d.data.SFMediaSubmission.Last_Date_of_Upload__c);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log('[I] alreday stats api response ', err);
      });
  }, []);

  const startUpload = function startUpload() {
    if (startMarkedInSF || alreadyUploadedFiles.length) {
      console.log('[I] start already marked', startMarkedInSF, alreadyUploadedFiles.length);
      return;
    } else {
      setStartMarkedInSF(true);
    }
    const startUploadUrl = `${API}/v1/upload/${SFMediaSubmissionID}/start`;
    axios
      .put(startUploadUrl)
      .then((d) => {
        console.log('[I] upload start mark done', d);
      })
      .catch((err) => {
        console.log('[I] upload start mark failure. ');
      });
  };

  const handleClose = (e) => {
    return false;
    // console.log('[I] Complete popup closed. Reset things...');
    // window.location.reload();
  };

  const deleteSingle = (folder, filename, already, deletedError) => {
    let key = folder + '/' + filename;
    if (already) {
      key = filename.replace('SFMediaSubmissions/', '');
    }
    console.log('[*] deleteSingle', key);
    const alreadyStatsUrl = `${API}/v1/upload/${SFMediaSubmissionID}`;
    axios
      .delete(alreadyStatsUrl, {
        data: { key },
      })
      .then((d) => {
        if (d.data && d.data.success) {
          console.log('File Delete success');

          // setDeletedFiles((prevDeletedFiles) => {
          //   console.log(prevDeletedFiles);
          //   return [...prevDeletedFiles, filename];
          // });

          if (already) {
            setAlreadyUploadedFiles((currentFiles) =>
              currentFiles.filter((file) => {
                console.log('file,filename', file, filename);
                return file.Key !== filename;
              })
            );
          } else {
            setAcceptedFileState((currentFiles) =>
              currentFiles.filter((file) => {
                return file.path !== filename;
              })
            );
            if (!deletedError) {
              console.log('Normal file deleted. updating state');
              setDeletedFiles([...deletedFiles, key]);
            } else {
              setTotalFailed((tf) => --tf);
              console.log('Error file deleted. not updating state.');
            }
          }
        } else {
          console.log('[W] Unable to delete file', d.data);
        }
      })
      .catch((err) => {
        console.log('[E]  Error deleting file ', err);
      });
  };

  const retryAll = () => {
    console.log('[*] retryAll');
    if (delayQueueState && delayQueueState.retry) {
      delayQueueState.retry();
    } else {
      console.log('please drop some files to retry');
    }
  };

  const abort = () => {
    console.log('[*] abort');
    window.location.reload();
    // removeExitPopup();
  };

  const toggleCompleted = (event) => {
    event.currentTarget.classList.toggle('disable');

    if (showCompletedFiles) {
      setShowcompletedFiles(false);
    } else {
      setShowcompletedFiles(true);
    }
  };

  const togglePending = (event) => {
    event.currentTarget.classList.toggle('disable');

    if (showPendingFiles) {
      setShowPendingFiles(false);
    } else {
      setShowPendingFiles(true);
    }
  };

  const toggleFailed = (event) => {
    event.currentTarget.classList.toggle('disable');

    if (showFailedFiles) {
      setShowFailedFiles(false);
    } else {
      setShowFailedFiles(true);
    }
  };

  const deleteFolder = (folder) => {
    const deleteFolderUrl = `${API}/v1/upload/${SFMediaSubmissionID}/all`;
    axios
      .delete(deleteFolderUrl)
      .then((d) => {
        if (d.data && d.data.success) {
          console.log('Folder delete success');

          setAcceptedFileState([]);
          window.location.reload();
        } else {
          console.log('[W] Unable to delete folder', d.data);
        }
      })
      .catch((err) => {
        console.log('[E]  Error deleting folder ', err);
      });
  };

  const markUploadComplete = async function markUploadComplete(droppedFiles) {
    console.log('[*] markUploadComplete', droppedFiles.length);
    const file_name_list = droppedFiles.map((df) => df.path);

    try {
      const chunkSize = 3000;
      for (let i = 0; i < file_name_list.length; i += chunkSize) {
        const chunk = file_name_list.slice(i, i + chunkSize);
        const reqData = {
          file_name_list: chunk,
        };
        console.log('[I] reqData: ', reqData);
        let markCompleteResult = await axios.put(`${API}/v1/upload/${SFMediaSubmissionID}/complete`, reqData);
        console.log('[I] markCompleteResult: ', markCompleteResult.data.message);
      }

      // setModalOpen(true);
      enqueueSnackbar('File upload completed.', { variant: 'success' });
      return true;
      // return markCompleteResult.data.success;
    } catch (markCompleteError) {
      console.log('markCompleteRequest Failed', markCompleteError);
    }

    return false;
  };

  const confirmUpload = async function confirmUploadFn() {
    try {
      let confirmResponse = await axios.put(`${API}/v1/upload/${SFMediaSubmissionID}/confirm`);
      console.log('[I] confirmResponse: ', confirmResponse.data.message);
      removeExitPopup();
      if (confirmResponse.data.success) {
        enqueueSnackbar('File upload completed.', { variant: 'success' });
        setAlreadyDate(new Date().toISOString());
        setAlreadyCount(confirmResponse.data.allFiles.length);

        setModalOpen(true);
        return true;
      }

      // setModalOpen(true);

      // return markCompleteResult.data.success;
    } catch (markCompleteError) {
      console.log('confirmUpload Failed', markCompleteError);
    }

    return false;
  };

  const onDrop = useCallback(async (acceptedFiles) => {
    console.log('[I] acceptedFiles[0]', acceptedFiles[0]);
    setUploadInProgress(true);
    let initalFilesStatus = acceptedFiles.map((aF) => {
      return {
        name: aF.name,
        path: cleanPath(aF.path),
        lastModified: aF.lastModified,
        size: aF.size,
        type: aF.type,
        uploaded: 'queued',
        progress: 0,
        retries: 0,
      };
    });

    if (acceptedFiles.length > 0 && !uploadInProgress) {
      setAcceptedFileState((prevState) => {
        console.log('prev filesQueue state: ', prevState);

        // let nonDups = initalFilesStatus.filter((f1) => !prevState.some((f2) => f1.name === f2.name));

        // initalFilesStatus = nonDups;

        return [...initalFilesStatus, ...prevState];
      });
      // setTotalPending(acceptedFiles.length);

      startUpload();
      setUploadStarted(true);

      let allFilesTotalSize = acceptedFiles.reduce((totalSize, currentValue) => totalSize + currentValue.size, 0);
      let totalUploadedSize = 0;
      setTotalFilesRemaining(acceptedFileState.length);
      setTotalSizeRemaining(allFileTotalSize);
      setAllFileTotalSize(allFilesTotalSize);

      let uploadTasks = [];
      for (let file of acceptedFiles) {
        uploadTasks.push({ file, retry: 0, path: cleanPath(file.path) });
      }

      const delayQueue = new PromiseQueue(
        uploadTasks,
        10,
        setAcceptedFileState,
        setCurrentKbps,
        setUploadStarted,
        setTotalFilesRemaining,
        setTotalSizeRemaining,
        SFMediaSubmissionID,
        markUploadComplete,
        setTotalFailed,
        setUploadInProgress,
        setTotalPending,
        setTotalUploaded,
        sortBy,
        acceptedFileState
      );
      console.log('>>>look at upload tasks: ', uploadTasks);
      delayQueue.run();
      setDelayQueueState(delayQueue);
    } else {
      console.error('Currently files are in progress. let them finish first.');
    }
  });

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <Fragment>
      <HeaderNew SFMediaSubmissionID={SFMediaSubmissionID} />
      <section className="media-uploader">
        {loading ? (
          <div className="loader">
            <img src="../../../pending.svg" alt="" />
          </div>
        ) : (
          ''
        )}

        {alreadyDate ? (
          <div className="already-stats">
            <ul>
              <li>Last uploaded Date: {alreadyDate}</li>
              <li>Already Uploaded Count: {alreadyCount}</li>
            </ul>
          </div>
        ) : (
          ''
        )}

        <div className="uploader-container">
          {/*<div className="media-uploader-header">
            <h1>Media Uploader</h1>
            <p>
              The number of images you have uploaded (5000) does not match the number you entered on the survey (326).
              To fix this, either go to the Post Event Review to update the image count, or add/remove images from the
              list below.
            </p> 
          </div>
  */}
          {/* <div {...getRootProps()} style={{ height: 200, padding: '20px', textAlign: 'center', border: '1px solid black', margin: '10px' }}
                    >
                        <input {...getInputProps()} />
                        {isDragActive ? <p>Drop the files here ...</p> : <p>Drag 'n' drop some files here, or click to select files</p>}
                    </div> */}
          {!loading && !uploadInProgress ? (
            <div className="uploader-box" {...getRootProps()}>
              <input {...getInputProps()} />
              {isDragActive ? (
                <h2>Drag photos here, or click to browse your computer for files.</h2>
              ) : (
                <div>
                  <h2>Drag photos here, or click to browse your computer for files.</h2>
                  {/* <p>Don't worry, if you choose a file which has already been uploaded, we won't upload it again.</p> */}
                </div>
              )}
            </div>
          ) : (
            ''
          )}

          <div className="uploader-buttons">
            {uploadStarted || alreadyUploadedFiles.length ? (
              <ul className="uploader-buttons-list">
                <li className="upload-complete">
                  <span
                    onClick={(event) => {
                      toggleCompleted(event);
                    }}
                  >
                    {totalUploaded - deletedFiles.length} Uploaded
                  </span>
                </li>
                <li className="upload-pending">
                  <span
                    onClick={(event) => {
                      togglePending(event);
                    }}
                  >
                    {totalPending} Pending
                  </span>
                </li>
                <li className="upload-failed">
                  <span
                    onClick={(event) => {
                      toggleFailed(event);
                    }}
                  >
                    {totalFailed} Failed
                  </span>
                </li>
              </ul>
            ) : (
              ''
            )}

            {(alreadyUploadedFiles.length || acceptedFileState.length) && !uploadInProgress ? (
              <ul className="uploader-buttons-list buttons-right">
                {totalFailed ? (
                  <li
                    id="retryUpload"
                    className="upload-retry"
                    onClick={(e) => {
                      retryAll();
                    }}
                  >
                    <span>Retry</span>
                  </li>
                ) : (
                  ''
                )}

                <li
                  id="confirmUpload"
                  className="upload-complete"
                  onClick={(e) => {
                    confirmUpload();
                  }}
                >
                  <span>Confirm Upload</span>
                </li>
                <li
                  className="upload-failed"
                  id="deleteAll"
                  onClick={(e) => {
                    deleteFolder(SFMediaSubmissionID);
                  }}
                >
                  <span>Delete All</span>
                </li>
              </ul>
            ) : (
              ''
            )}

            {uploadInProgress ? (
              <ul className="uploader-buttons-list buttons-right">
                <li
                  className="upload-failed"
                  id="abort"
                  onClick={(e) => {
                    abort();
                  }}
                >
                  <span>Cancel</span>
                </li>
              </ul>
            ) : (
              ''
            )}
          </div>

          {uploadStarted ? (
            <div className="media-uploader-files">
              <ul className="uploader-files-list">
                {showFailedFiles
                  ? acceptedFileState
                      .filter((aFf) => aFf.uploaded !== 'uploaded' && aFf.uploaded !== 'queued')
                      .map((aF) => (
                        <li key={aF.path}>
                          <div className="upload-files-meta">
                            <FileStatusIcon uploaded={aF.uploaded} />

                            <div className="uploader-file-name">
                              <span>{aF.path}</span>
                              <span title={aF.size + ' bytes'}>{bytesToSize(aF.size)}</span>
                            </div>

                            {!uploadInProgress ? (
                              <div className="uploader-file-delete">
                                <img
                                  onClick={() =>
                                    deleteSingle(SFMediaSubmissionID, aF.path, false, aF.uploaded === 'error')
                                  }
                                  src="../../../delete.svg"
                                  alt=""
                                />
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </li>
                      ))
                  : ''}

                {showPendingFiles
                  ? acceptedFileState
                      .filter((aFf) => aFf.uploaded === 'queued')
                      .map((aF) => (
                        <li key={aF.path}>
                          <div className="upload-files-meta">
                            <FileStatusIcon uploaded={aF.uploaded} />

                            <div className="uploader-file-name">
                              <span>{aF.path}</span>
                              <span title={aF.size + ' bytes'}>{bytesToSize(aF.size)}</span>
                            </div>

                            {!uploadInProgress ? (
                              <div className="uploader-file-delete">
                                <img
                                  onClick={() =>
                                    deleteSingle(SFMediaSubmissionID, aF.path, false, aF.uploaded === 'error')
                                  }
                                  src="../../../delete.svg"
                                  alt=""
                                />
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </li>
                      ))
                  : ''}

                {showCompletedFiles
                  ? acceptedFileState
                      .filter((aFf) => aFf.uploaded === 'uploaded')
                      .map((aF) => (
                        <li key={aF.path}>
                          <div className="upload-files-meta">
                            <FileStatusIcon uploaded={aF.uploaded} />

                            <div className="uploader-file-name">
                              <span>{aF.path}</span>
                              <span title={aF.size + ' bytes'}>{bytesToSize(aF.size)}</span>
                            </div>

                            {!uploadInProgress ? (
                              <div className="uploader-file-delete">
                                <img
                                  onClick={() =>
                                    deleteSingle(SFMediaSubmissionID, aF.path, false, aF.uploaded === 'error')
                                  }
                                  src="../../../delete.svg"
                                  alt=""
                                />
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </li>
                      ))
                  : ''}
              </ul>
            </div>
          ) : (
            ''
          )}

          {alreadyUploadedFiles.length ? (
            <div className="media-uploader-files">
              <div className="already-heading">Already Uploaded Files</div>
              <ul className="uploader-files-list">
                {alreadyUploadedFiles.map((aF) => (
                  <li key={formatFilename(aF.Key, SFMediaSubmissionID)}>
                    <div className="upload-files-meta">
                      <FileStatusIcon uploaded={'uploaded'} />

                      <div className="uploader-file-name">
                        <span>{formatFilename(aF.Key, SFMediaSubmissionID)}</span>
                        <span title={aF.Size + ' bytes'}>{bytesToSize(aF.Size)}</span>
                      </div>
                      <div className="uploader-file-delete">
                        <img
                          onClick={() => deleteSingle(SFMediaSubmissionID, aF.Key, true, false)}
                          src="../../../delete.svg"
                          alt=""
                        />
                      </div>
                      {/* {!uploadInProgress ? (
                        <div className="uploader-file-delete">
                          <img
                            onClick={() =>
                              deleteSingle(SFMediaSubmissionID, formatFilename(aF.Key, SFMediaSubmissionID))
                            }
                            src="../../../delete.svg"
                            alt=""
                          />
                        </div>
                      ) : (
                        ''
                      )} */}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            ''
          )}
        </div>

        {/* <div>
          <button
            id="deleteAll"
            onClick={(e) => {
              deleteFolder(SFMediaSubmissionID);
            }}
          >
            Delete All
          </button>
        </div> */}
        <UploadCompleteModal
          handleClose={handleClose}
          imageCount={
            alreadyDate ? alreadyCount : acceptedFileState.length + alreadyUploadedFiles.length - deletedFiles.length
          }
          open={alreadyDate ? true : modalOpen}
          already={alreadyDate ? true : false}
        />
      </section>
      <div className="footer">2022 © Orion Photo Group</div>
    </Fragment>
  );
}
